import type { YearlyRevenue } from '@vy/types';
import type { MonthColumn } from './build-month-columns';

type RowKey = 'scheduledCharge' | 'revenue' | 'deferredRevenue' | 'unbilledRevenue';

export function buildRowValues(
  yearlyRevenue: YearlyRevenue,
  columns: MonthColumn[],
  key: RowKey,
  carryForward: boolean,
): number[] {
  let last = 0;

  return columns.map((column) => {
    const breakdown = yearlyRevenue[column.year]?.[column.month];

    if (breakdown) {
      const value = breakdown[key] ?? 0;
      if (carryForward) last = value;
      return value;
    }

    return carryForward ? last : 0;
  });
}
